import Api from '@/api/index';
import shared_address_default from '@/store/shared/DefaultAddress.js'
import shared_contact_default from '@/store/shared/DefaultContact.js'
import shared_client_default from '../../../../store/shared/DefaultClient'

const Client = {
  namespaced: true,
  state: {

    one_client: {
      ...shared_client_default
    },

    allClients: []
  },
  getters: {
    getOneClient: state => {
      return state.one_client
    }
  },

  mutations: {
    setAllClients(state, data){
      state.allClients = [...data]
    },

    copyMainAddressToFirstShipping(state){
      state.one_client.shipping_addresses.splice(0, 1, {...state.one_client.address})
    },

    addNewContact(state) {
      state.one_client.contacts.push({...shared_contact_default})
    },

    removeContact(state, contact_id) {
      if (contact_id == null || contact_id == undefined) {
        state.one_client.contacts.pop()
      } else {
        const idx = state.one_client.contacts.findIndex(c => c.id == contact_id)
        state.one_client.contacts.splice(idx, 1)
      }
    },

    addNewShippingAddress(state) {
      state.one_client.shipping_addresses.push({...shared_address_default})
    },

    removeShippingAddress(state, address_id) {
      if (address_id == null || address_id == undefined) {
        state.one_client.shipping_addresses.pop()
      } else {
        const idx = state.one_client.shipping_addresses.findIndex(a => a.id == address_id)
        state.one_client.shipping_addresses.splice(idx, 1)
      }
    },

    clearOneClient(state) {
      let {address, main_address, shipping_addresses, contacts, client_credit, ...base} = shared_client_default
      state.one_client = {
        ...state.one_client,
        ...base,
        ...shared_client_default
      }
      state.one_client.address = {
        ...address
      }
      state.one_client.main_address = {
        ...main_address
      }
      state.one_client.shipping_addresses = [
        ...shipping_addresses
      ]
      state.one_client.contacts = [
        {...shared_contact_default}
      ]
      state.one_client.client_credit = {
        ...client_credit
      }
      
    },

    addToAllClients(state, obj) {
      // console.log(obj)
      state.allClients.push({name: obj.name, id: obj.id})
      state.one_client = {
        ...shared_client_default
      }
    },

    setOneClient(state, obj) {
      obj.contacts = obj.contacts || []
      obj.shipping_addresses = obj.shipping_addresses || []
      state.one_client = {...state.one_client, ...obj}
    },

    updateOneClientMainData(state, main_data) {
      state.one_client = {
        ...state.one_client,
        ...main_data,
      }
    },

    updateOneClientAddress(state, address) {
      state.one_client.main_address = {...state.one_client.main_address, ...address}
    },

    updateOneClientContact(state, contact) {
      //podendo ser usado também o vue.set
      let idx = state.one_client.contacts.findIndex(c => c.id == contact.id)
      idx = idx>-1? idx : state.one_client.contacts.length
      state.one_client.contacts.splice(idx, 1, {...contact})
    },

    updateOneClientShippingAddress(state, address) {
      //podendo ser usado também o vue.set
      let idx = state.one_client.shipping_addresses.findIndex(a => a.id == address.id)
      idx = idx>-1? idx : state.one_client.contacts.length
      state.one_client.shipping_addresses.splice(idx, 1, {...address})
    },

    updateOneClientCredit(state, client_credit) {
      state.one_client.client_credit = {...client_credit}
    },

    updateOneClientComment(state, comment) {
      state.one_client = {
        ...state.one_client,
        comment: comment,
      }
    }
  },

  actions: {
    clearOneClient({commit}) {
      commit('clearOneClient')
    },

    addClientContact(context){
      context.commit('addNewContact')
    },

    copyMainAddressToFirstShipping(context){
      context.commit('copyMainAddressToFirstShipping')
    },

    deleteClientContact(context, {contact_id = null}){
      let notification = {}
      if (contact_id) {
        Api.RemoteContact.delete(contact_id).then(() => {
          context.commit('removeContact', contact_id)
          notification.type = 'success'
          notification.msg = 'Contato deletado com sucesso'
        }).catch(err => {
          notification.type =  'error'
          notification.msg = `Erro: ${err}`
        }).finally(() => {
          context.dispatch('Notification/add', notification, {root: true})
        })
      } else {
        context.commit('removeContact', contact_id)
      }
    },

    addClientShippingAddress(context) {
      context.commit('addNewShippingAddress')
    },

    deleteClientShippingAddress(context, {address_id = null}) {
      let notification = {}
      if (address_id) {
        Api.RemoteAddress.delete(address_id).then(() => {
          context.commit('removeShippingAddress', address_id)
          notification.type = 'success'
          notification.msg = 'Endereço deletado com sucesso'
        }).catch(err => {
          notification.type =  'error'
          notification.msg = `Erro: ${err}`
        }).finally(() => {
          context.dispatch('Notification/add', notification, {root: true})
        })
      } else {
        context.commit('removeShippingAddress', address_id)
      }
    },

    saveMainData(context, {main_data}) {
      let notification = {}
      Api.FinancialClient.update(main_data).then(r => r.data).then(r => {
        context.commit('updateOneClientMainData', r)
        notification.type = 'success'
        notification.msg = 'Informações básicas atualizadas'
      }).catch(err => {
        notification.type =  'error'
        notification.msg = `Erro: ${err}`
      }).finally(() => {
        context.dispatch('Notification/add', notification, {root: true})
      })
    },

    saveAddress(context, address) {
      let notification = {}
      
      Api.RemoteAddress.update(address).then(r => r.data).then(addr => {
        context.commit('updateOneClientAddress', addr)
        notification.type = 'success'
        notification.msg = 'Endereço atualizado'
      }).catch(err => {
        notification.type =  'error'
        notification.msg = `Erro: ${err}`
      }).finally(() => {
        context.dispatch('Notification/add', notification, {root: true})
      })
    },

    saveContact(context, contact) {
      let notification = {}
      contact.contactable_type = 'Client'
      contact.contactable_id = context.state.one_client.id
      const ACTION = contact.id ? 'update' : 'create'
      Api.RemoteContact[ACTION](contact).then(r => r.data).then(cont => {
        context.commit('updateOneClientContact', cont)
        notification.type = 'success'
        notification.msg = 'Contato atualizado'
      }).catch(err => {
        notification.type =  'error'
        notification.msg = `Erro: ${err}`
      }).finally(() => {
        context.dispatch('Notification/add', notification, {root: true})
      })
    },

    saveShippingAddress(context, address) {
      let notification = {}
      address.addressable_type = 'Client'
      address.addressable_id = context.state.one_client.id
      const ACTION = address.id ? 'update' : 'create'
      Api.RemoteAddress[ACTION](address).then(r => r.data).then(addr => {
        context.commit('updateOneClientShippingAddress', addr)
        notification.type = 'success'
        notification.msg = 'Endereço de entrega atualizado'
      }).catch(err => {
        notification.type =  'error'
        notification.msg = `Erro: ${err}`
      }).finally(() => {
        context.dispatch('Notification/add', notification, {root: true})
      })
    },

    saveCredit(context, {client_credit, id}) {
      let notification = {}
      return Api.ClientCredit.update(client_credit).then(r => r.data).then(credit => {
        context.commit('updateOneClientCredit', credit)
        notification.type = 'success'
        notification.msg = 'Informações de crédito atualizadas'
        return true
      }).catch(err => {
        notification.type =  'error'
        notification.msg = `Erro: ${err}`
        throw Error(err)
      }).finally(() => {
        context.dispatch('Notification/add', notification, {root: true})
      })
    },

    saveComment(context, comment) {
      let notification = {}
      return Api.FinancialClient.update(comment).then(r => r.data).then(r => {
        context.commit('updateOneClientComment', r.comment)
        notification.type = 'success'
        notification.msg = 'Comentário atualizado'
        return r.comment
      }).catch(err => {
        notification.type =  'error'
        notification.msg = `Erro: ${err}`
      }).finally(() => {
        context.dispatch('Notification/add', notification, {root: true})
      })
    },

    index(context, filter) {
      return Api.FinancialClient.index(filter).then(r => r.data).then(r => {
        // console.log({r})
        r = r.data? r.data.map(c=>c.attributes) : r
        context.commit('setAllClients', r)
      }).catch(error => {
        console.log(error)
      })
    },

    createClient(context, {client}) {
      let notification = {}
      return Api.FinancialClient.create(client).then(r => r.data).then(r => {
        notification.type = 'success'
        notification.msg = 'Cliente cadastrado com sucesso'
        context.dispatch('clearOneClient')
        return true
      }).catch(err => {
        err = err.response && err.response.data && err.response.data.errors || err
        notification.type = 'error'
        notification.msg = `Erro: ${err}`
        notification.timer = 60000
        console.log(err)
        throw Error(err)
      }).finally(() => {
        context.dispatch('Notification/add', notification, {root: true})
      })
    },

    showOneClient(context, id) {
      return Api.FinancialClient.show(id).then(r => r.data).then(r => {
        // console.log(r)
        r = r.data? r.data.attributes : r
        context.commit('setOneClient', r)
        return true
      }).catch(error => {
        console.log(error)
      })
    }
  }

};

export default Client;
